import React from 'react'
import { Spin } from 'antd'
import { CustomLoadingOverlayProps } from 'ag-grid-react'
import { useTranslation } from 'react-i18next'

const CustomLoadingOverlay: React.FC<CustomLoadingOverlayProps> = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Spin size="large" />
    </div>
  )
}

export default CustomLoadingOverlay
